import { render, staticRenderFns } from "./LeftRightFooter.vue?vue&type=template&id=6f9be8ce&"
import script from "./LeftRightFooter.vue?vue&type=script&lang=ts&"
export * from "./LeftRightFooter.vue?vue&type=script&lang=ts&"
import style0 from "./LeftRightFooter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports